import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useTitle } from './TitleContext'; // Import the provider
import PosSen1 from '../images/pos-sen demo 1.png';
import PosSen2 from '../images/pos-sen demo 2.png';
import PosSen3 from '../images/pos-sen demo 3.png';
import PosSen4 from '../images/pos-sen demo 4.png';
import PosSen5 from '../images/pos-sen demo 5.png';
import './PositivitySentiment.css';


function PositivitySentiment() {
    const navigate = useNavigate()
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle("Sentiment Bias Tracker"); // Set the title for the home page
  }, [setTitle]);
  const goHome = () => {
    navigate('/');  // Navigate to the home page
    window.scrollTo(0, 0);  // Scroll to the top of the page
  };
  return (
    <div className="main-content">
        <div className="tracker-container">
          <img src={PosSen1} alt="Fortune article"/>
          <div className="pos-sen-tracker-info-wrapper">
            <div className="pos-sen-tracker-info">
              <p><span className="highlight">Source:</span> Fortune </p>
              <p><span className="highlight">Category:</span> News</p>
              <p><span className="highlight">Date:</span> 2/18/24 </p>
              <p><span className="highlight">Score:</span> -14 </p>
              <a href="https://finance.yahoo.com/news/fast-food-giants-feeling-burn-110000726.html" target="_blank">Link</a>
            </div>
          </div>
        </div>

        <div className="tracker-container">
          <img src={PosSen2} alt="CBS Article"/>
          <div className="pos-sen-tracker-info-wrapper">
          <div className="pos-sen-tracker-info">
              <p><span className="highlight">Source:</span> CBS News</p>
              <p><span className="highlight">Category:</span> News</p>
              <p><span className="highlight">Date:</span> 11/16/23 </p>
              <p><span className="highlight">Score:</span> -22 </p>
              <a href="https://www.cbsnews.com/texas/news/problems-percolating-for-starbucks-as-workers-strike-on-red-cup-day/" target="_blank">Link</a>
            </div>
          </div>
        </div>

        <div className="tracker-container">
          <img src={PosSen3} alt="Time Magazine Article"/>
          <div className="pos-sen-tracker-info-wrapper">
            <div className="pos-sen-tracker-info">
              <p><span className="highlight">Source:</span> Time Magazine</p>
              <p><span className="highlight">Category:</span> News</p>
              <p><span className="highlight">Date:</span> 11/14/23 </p>
              <p><span className="highlight">Score:</span> -16 </p>
              <a href="https://time.com/6694986/israel-palestine-bds-boycotts-starbucks-mcdonalds/" target="_blank">Link</a>
            </div>
          </div>
        </div>
        
        <div className="tracker-container">
          <img src={PosSen4} alt="88 tweet"/>
          <div className="pos-sen-tracker-info-wrapper">
            <div className="pos-sen-tracker-info">
              <p><span className="highlight">Source:</span> X (Twitter)</p>
              <p><span className="highlight">Category:</span> Social Media</p>
              <p><span className="highlight">Date:</span> 2/9/24 </p>
              <p><span className="highlight">Score:</span> -23 </p>
              <p><span className="highlight">Views:</span> 41 </p>
              <a href="https://twitter.com/88Expert/status/1755911433844629534" target="_blank">Link</a>
            </div>
          </div>
        </div>

        <div className="tracker-container">
          <img src={PosSen5} alt="OGoldash tweet"/>
          <div className="pos-sen-tracker-info-wrapper">
            <div className="pos-sen-tracker-info">
              <p><span className="highlight">Source:</span> X (Twitter) </p>
              <p><span className="highlight">Category:</span> Social Media</p>
              <p><span className="highlight">Date:</span> 2/6/24 </p>
              <p><span className="highlight">Score:</span> -42 </p>
              <p><span className="highlight">Views:</span> 2,381 </p>
              <a href="https://twitter.com/OGoldash/status/1754895906170630209" target="_blank">Link</a>
            </div>
          </div>
        </div>

        <div className="tracker-info">
            <button onClick={goHome}>Return</button>
        </div>
    </div>
  );
}

export default PositivitySentiment;